import type { PopoutContent } from "~/contexts/PopoutManagerContext";

export const POPOUT_GAP_PX = 12;

// Above sticky page chrome (z-20 to z-39) but below the @remi/next-ui
// floating-UI tier (z-50) so dropdowns/menus/tooltips opened inside a
// popout still layer correctly.
export const POPOUT_Z_INDEX_BASE = 40;

export const POPOUT_WIDTH_BY_KIND = {
  conversation: 480,
  ticket: 640,
  task: 600,
} as const;

export const POPOUT_HEIGHT_BY_KIND = {
  conversation: 560,
  ticket: 780,
  task: 760,
} as const;

// Past this width the "More details" collapsible is swapped for a persistent side pane.
export const TASK_POPOUT_SIDEBAR_BREAKPOINT_PX = 768;
export const TASK_POPOUT_SIDEBAR_WIDTH_PX = 384;

export const getPopoutWidth = (content: PopoutContent): number => POPOUT_WIDTH_BY_KIND[content.kind];
